import React from 'react';
import { bulkUpdateInterviewSchedules } from '../../../../../services/apiService';
import { Modal, Button, Table, Label, Icon } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberInput from 'semantic-ui-react-numberinput';
import RenderProfilePic from '../../../../../extras/RenderProfilePic';
import { getFullName } from '../../../../../utils';
const moment = require('moment');

const BulkInterviewScheduleUpdateModal = ({
  setIsBulkInterviewScheduleModalOpen,
  isBulkInterviewScheduleModalOpen,
  selectedJobApplications,
  manualControlForBulkUpdateFilterIsActive,
  setManualControlForBulkUpdateFilterIsActive,
  startDateForBulkInterviewSchedule,
  setStartDateForBulkInterviewSchedule,
  assignmentTypeForBulkUpdateFilterIsActive,
  setAssignmentTypeForBulkUpdateFilterIsActive,
  setSelectedJobApplicationsData,
  selectedJobApplicationsData,
  bulkInterviewSchedulesApplyTimeBtnRef,
  jobGroupDetails,
  setSelectedJobApplications,
  getJobDetailsById,
  fetchJobApplicationsForJobGroup,
}) => {
  // bulk update interview schedules
  const bulkUpdateSchedules = async (interviewSchedules = []) => {
    try {
      const _payload = selectedJobApplicationsData.map((candidate, i) => {
        const _currentRoundNumber = candidate[0]?.data?.currentRoundNumber;
        const _selectedRound = candidate.filter(
          (_candidate) => _candidate?.data?.roundNumber === _currentRoundNumber
        )[0]?.data;

        return {
          roundId: _selectedRound?.roundId ?? null,
          schedule: manualControlForBulkUpdateFilterIsActive
            ? new Date(_selectedRound?.schedule) ?? new Date()
            : startDateForBulkInterviewSchedule,
          roundType: _selectedRound?.roundType,
        };
      });
      await bulkUpdateInterviewSchedules({
        schedules: _payload.filter((schedule) => schedule.roundId !== null),
      });
      // fetch job group details again
      await getJobDetailsById(jobGroupDetails.groupId);
      // fetch job applications again
      await fetchJobApplicationsForJobGroup(jobGroupDetails.groupId);
      setSelectedJobApplications([]);
      setIsBulkInterviewScheduleModalOpen(false);
    } catch (error) {
      console.log('error in bulk update status::', error);
    }
  };

  const SchedulePicker = React.memo(
    ({ startDate, onScheduleHandler, roundId }) => {
      return (
        <div className='flex flex-row justify-between break-word '>
          <Icon name='clock outline' size='large' />
          <div className='flex flex-col justify-center'>
            <DatePicker
              selected={new Date(startDate)}
              showTimeSelect
              showIcon={true}
              dateFormat='MMMM d, h:mm aa'
              onChange={(date) => {
                onScheduleHandler(date, roundId);
              }}
              className='text-xs font-semibold'
              // customInput={<ExampleCustomInput />}
              style={{
                width: '80%',
                backgroundColor: '#EBF2FC',
                color: '#e20',
              }}
            />
          </div>
        </div>
      );
    }
  );
  SchedulePicker.displayName = 'SchedulePicker';

  const renderInterviewSchedule = (_roundType, _startTime, _deadline) => {
    if (!_startTime && !_deadline)
      return <span className=' text-xs  font-semibold'>Not Scheduled</span>;

    if (_startTime && !_deadline)
      return (
        <span className='text-xs font-semibold'>
          {moment(_startTime).format('MMMM Do , h:mm a')}
        </span>
      );

    if (!_startTime && _deadline)
      return (
        <span className='text-xs font-semibold'>
          {moment(_deadline).format('MMMM Do , h:mm a')}
        </span>
      );

    return (
      <span>
        {_roundType === 'interview'
          ? `${moment(_startTime).format('MMMM Do , h:mm a')}`
          : `${moment(_deadline).format('MMMM Do , h:mm a')}`}
      </span>
    );
  };

  const BulkUpdateInterviewScheduleTableRows = React.memo(
    ({ jobApplicationRowData, index }) => {
      const row = jobApplicationRowData.filter(
        (application) =>
          application?.data?.roundNumber ===
          jobApplicationRowData[0].data.currentRoundNumber
      )[0]?.data;

      return (
        <Table.Row
          key={row?.email}
          sx={{
            '&:last-child td, &:last-child th': { border: 0 },
          }}
          disabled={
            row?.jobApplicationDetails?.currentStatus === 'offer made' ||
            row?.jobApplicationDetails?.currentStatus === 'rejected' ||
            (assignmentTypeForBulkUpdateFilterIsActive &&
              row?.roundType === 'interview')
          }
        >
          <Table.Cell
            align='right'
            className='font-semibold text-base text-gray-c4'
          >
            {row?.jobApplicationDetails?.currentStatus === 'offer made' && (
              <Label ribbon color='green'>
                Offer made
              </Label>
            )}
            {row?.jobApplicationDetails?.currentStatus === 'rejected' && (
              <Label ribbon>Rejected</Label>
            )}
            {/* Create a avatar component here row.userDetails.thumbnail */}
            <RenderProfilePic
              thumbnail={row?.userDetails?.thumbnail}
              name={getFullName(row?.userDetails)}
              size={2}
              className={`${
                row?.jobApplicationDetails?.currentStatus === 'offer made' ||
                row?.jobApplicationDetails?.currentStatus === 'rejected' ||
                (assignmentTypeForBulkUpdateFilterIsActive &&
                  row?.roundType === 'interview')
                  ? 'opacity-50'
                  : ''
              }`}
            />
            {row?.candidate ?? ''}{' '}
          </Table.Cell>
          <Table.Cell align='right' collapsing>
            <NumberInput
              value={row?.currentRoundNumber ?? 1}
              onChange={(value, newValue) => {
                if (row?.currentRoundNumber) {
                  setSelectedJobApplicationsData(
                    selectedJobApplicationsData.map((candidate) => {
                      // map over each candidate and change their currentRouhdNumber to the roundNumber of the round that has roundType : 'assignment'
                      // find out the element which has roundType : 'assignment'.
                      // map through candidate and change the currentRoundNumber to the roundNumber of the _assignmentRound
                      const _candidate = candidate.map((round) => {
                        if (
                          round.data.jobApplicationId === row.jobApplicationId
                        ) {
                          round.data.currentRoundNumber = +value;
                        }

                        return round;
                      });
                      // return the candidate with the currentRoundNumber changed to the roundNumber of the _assignmentRound
                      return _candidate;
                    })
                  );
                }
              }}
              size='tiny'
              minValue={1}
              maxValue={
                [...Array(jobGroupDetails.numberOfRounds).keys()].length
              }
              width={2}
              // defaultValue={selectedRound}
              style={{ width: '50%' }}
            />
            {/* </div> */}
            {/* {row.currentRoundNumber} */}
          </Table.Cell>
          <Table.Cell align='right'>{row?.roundType}</Table.Cell>
          <Table.Cell
            align='right'
            className='font-semibold text-base text-gray-c4'
          >
            {/* have a Dropdown here with all the possible statuses */}
            {/* <Dropdown
                    placeholder='Select Status'
                    selection
                    options={bulkUpdateStatusOptions}
                    value={row?.status}
                    onChange={(e, { value }) => {

                    }}
                /> */}

            {row?.status}
          </Table.Cell>
          <Table.Cell align='right'>
            <div className='flex flex-row justify-start gap-1 '>
              <Icon name='calendar alternate outline' color='grey' />
              <div className='break-words text-xs font-semibold'>
                {renderInterviewSchedule(
                  row?.roundType,
                  row?.startTime,
                  row?.deadline
                )}
              </div>
            </div>
          </Table.Cell>
          <Table.Cell
            align='right'
            selectable
            className={`bg-white rounded-md px-4 py-2 text-sm font-medium ${
              !manualControlForBulkUpdateFilterIsActive
                ? 'text-gray'
                : ' text-brand-primary '
            }   hover:bg-gray-50 `}
            sx={{ minWidth: 650 }}
          >
            {!manualControlForBulkUpdateFilterIsActive ? (
              <div className='flex flex-row justify-start gap-1 '>
                {/* <Icon name='clock outline' className='px-2' /> */}
                <Icon
                  name='calendar alternate outline'
                  size='large'
                  color='grey'
                />
                <div className='text-xs font-semibold '>
                  {moment(startDateForBulkInterviewSchedule).format(
                    'MMMM Do, h:mm a'
                  )}
                </div>
              </div>
            ) : (
              <SchedulePicker
                startDate={row?.schedule}
                onScheduleHandler={(_schedule, _roundId) => {
                  setSelectedJobApplicationsData(
                    selectedJobApplicationsData.map((application) => {
                      application = application.map((round) => {
                        if (round.data.roundId === _roundId) {
                          round.data.schedule = _schedule;
                        }
                        return round;
                      });
                      // return the candidate with the currentRoundNumber changed to the roundNumber of the _assignmentRound
                      return application;
                    })
                  );
                  // setStartDate(_schedule);
                }}
                roundId={row?.roundId}
              />
            )}
          </Table.Cell>
        </Table.Row>
      );
    }
  );
  BulkUpdateInterviewScheduleTableRows.displayName =
    'BulkUpdateInterviewScheduleTableRows';

  return (
    <Modal
      onClose={() => setIsBulkInterviewScheduleModalOpen(false)}
      onOpen={() => setIsBulkInterviewScheduleModalOpen(true)}
      open={isBulkInterviewScheduleModalOpen}
    >
      <Modal.Header>
        <Icon name='clock outline' />
        Bulk Update Interview Schedule
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>
            <span className='text-base font-bold '>Note:</span>{' '}
            <span className='italic'>
              This action will update the interview round timmings of{' '}
              {selectedJobApplications.length} candidates to{' '}
            </span>
            <div className=' px-4 py-1 leading-tight text-gray-700 rounded focus:outline-none focus:bg-white focus:border-gray-500 my-25 '>
              <div className='flex flex-row justify-between'>
                <div
                  className={`w-1/4 flex flex-row justify-center  w-70 rounded ${
                    manualControlForBulkUpdateFilterIsActive
                      ? 'bg-gray-c2 cursor-not-allowed'
                      : 'bg-blue-c4'
                  } shadow-md`}
                  onClick={(e) => {
                    e.preventDefault();
                    // eslint-disable-line
                    const picker = document.getElementById(
                      'bulkInterviewSchedulesApplyTimeBtn'
                    );
                    picker.click();
                  }}
                >
                  <div className=' flex  justify-center align-center px-2 my-2  '>
                    <Icon name='calendar alternate outline' size='large' />
                  </div>
                  <div
                    className={`w-full flex flex-col  align-center justify-center `}
                  >
                    <span className='text-sm font-bold text-gray-700'>
                      {' '}
                      Bulk Apply Schedule :
                    </span>
                    <DatePicker
                      id='bulkInterviewSchedulesApplyTimeBtn'
                      disabled={manualControlForBulkUpdateFilterIsActive}
                      selected={new Date(startDateForBulkInterviewSchedule)}
                      showTimeSelect
                      ref={bulkInterviewSchedulesApplyTimeBtnRef}
                      dateFormat='MMMM d, h:mm aa'
                      onChange={(date) => {
                        setStartDateForBulkInterviewSchedule(date);
                      }}
                      className={`w-full ${
                        manualControlForBulkUpdateFilterIsActive
                          ? 'bg-gray-c2'
                          : 'bg-blue-c4'
                      } text-gray-500 rounded  font-semibold	 text-xs `}
                      style={{ width: '100%', background: 'inherit' }}
                    />
                  </div>
                </div>
                <div className='w-1/2 flex gap-2   justify-end px-5 py-1  '>
                  {/* PROG */}
                  <Button
                    toggle
                    // color={assignmentTypeForBulkUpdateFilterIsActive ? 'green' : 'grey'}
                    active={assignmentTypeForBulkUpdateFilterIsActive}
                    onClick={() => {
                      setAssignmentTypeForBulkUpdateFilterIsActive(
                        !assignmentTypeForBulkUpdateFilterIsActive
                      );
                      // we need to setSelectedJobApplicationData to set the currentRoundNumber of each entry to the round that has roundType : 'assignment" ( Note :-  selectedRow is  jobApplicationRowData[0].data.currentRoundNumber )
                      setSelectedJobApplicationsData(
                        selectedJobApplicationsData.map((candidate) => {
                          // map over each candidate and change their currentRouhdNumber to the roundNumber of the round that has roundType : 'assignment'
                          // find out the element which has roundType : 'assignment' .
                          const _assignmentRound = candidate.filter(
                            (round) => round?.data?.roundType === 'assignment'
                          )[0]?.data;
                          let _candidate = candidate;
                          if (_assignmentRound) {
                            // map through candidate and change the currentRoundNumber to the roundNumber of the _assignmentRound
                            _candidate = candidate.map((round) => {
                              round.data.currentRoundNumber =
                                _assignmentRound?.roundNumber;
                              return round;
                            });
                          }
                          // return the candidate with the currentRoundNumber changed to the roundNumber of the _assignmentRound
                          return _candidate;
                        })
                      );
                    }}
                  >
                    Assignments Only
                  </Button>
                  <Button
                    toggle
                    active={manualControlForBulkUpdateFilterIsActive}
                    onClick={() => {
                      setManualControlForBulkUpdateFilterIsActive(
                        !manualControlForBulkUpdateFilterIsActive
                      );
                    }}
                  >
                    Manual
                  </Button>
                </div>
              </div>
              <div className='flex flex-wrap justify-start mb-2 mt-10 '>
                {/* <TableContainer component={Paper}> */}
                <Table
                  aria-label='simple table'
                  className='w-full outline-0 border-0'
                  style={{ border: 'none' }}
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.Cell className='font-semibold '>
                        Candidate
                      </Table.Cell>
                      <Table.Cell className='font-semibold ' align='right'>
                        Round
                      </Table.Cell>
                      <Table.Cell className='font-semibold ' align='right'>
                        Type
                      </Table.Cell>
                      <Table.Cell className='font-semibold ' align='right'>
                        Status
                      </Table.Cell>
                      <Table.Cell className='font-semibold ' align='right'>
                        Schedule
                      </Table.Cell>
                      <Table.Cell className='font-semibold ' align='right'>
                        Updated Schedule
                      </Table.Cell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {selectedJobApplicationsData.map((row, index) => (
                      <BulkUpdateInterviewScheduleTableRows
                        jobApplicationRowData={row}
                        index={index}
                        key={index}
                      />
                    ))}
                  </Table.Body>
                </Table>
                {/* </TableContainer> */}
              </div>
            </div>
          </p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <button
          onClick={(e) => {
            e.preventDefault();
            setIsBulkInterviewScheduleModalOpen(false);
          }}
          className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400 bg-white'
        >
          Cancel
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            bulkUpdateSchedules();
          }}
          className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
        >
          Update
        </button>
      </Modal.Actions>
    </Modal>
  );
};

export default BulkInterviewScheduleUpdateModal;
